import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Result, Button } from 'antd';

const Page403: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
            extra={
                <Button type="primary" onClick={() => navigate('/')}>
                    Back Home
                </Button>
            }
        />
    );
};

export default Page403;
